import { first } from 'rxjs/operators';
import { MAT_DIALOG_DATA, MatDialog, MatDialogConfig } from '@angular/material/dialog';
import {Component, Inject, Input, OnInit, ViewChild} from '@angular/core';
import { AlertService } from '@app/_services';
import { LazyLoadEvent, MessageService, ConfirmationService } from 'primeng/api';
import { ReservationLedgerService } from '../reservation-ledger.service';
import { ReservationLedger } from '../reservation-ledger';
import { ReservationLedgerComponent } from '../reservation-ledger/reservation-ledger.component';
import {ImportExportComponent} from '@app/_components/_helpers/import-export/import-export.component';
import {ActivatedRoute} from '@angular/router';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { TravelAgentProfileService } from '@app/_components/travel-agent-profile/travel-agent-profile.service';

@Component({
    selector: 'app-reservation-ledger-list',
    templateUrl: './reservation-ledger-list.component.html',
    styleUrls: ['./reservation-ledger-list.component.css'],
    // make column heading sticky
    styles: [`
        :host ::ng-deep .p-datatable .p-datatable-thead > tr > th {
            position: -webkit-sticky;
            position: sticky;
            top: 0px;
        }

        @media screen and (max-width: 64em) {
            :host ::ng-deep .p-datatable .p-datatable-thead > tr > th {
                top: 99px;
            }
        }
`],
    standalone: false
})
export class ReservationLedgerListComponent implements OnInit {
    payToDetails: any;
	showFilter = true;
	showPagination = true;
	displayClose = true;
	reservationId: any;
	ruReservationId: any;

	title: any;
	isSearching = false;
	grandTotalAmount: any;
	@ViewChild(ImportExportComponent) importExportComponent: ImportExportComponent;
	addIntoOwnerStatementPopUp = false;
	percentages: { value: number; name: string; }[];
	addTravelAgentPopUp = false;
	isPopup = false;
	agentProfileSuggestions: any[] = [];
	selectedAgentProfile: any = null;
	constructor(
		private reservationLedgerService: ReservationLedgerService,
		private alertService: AlertService,
		private formBuilder: UntypedFormBuilder,
		private messageService: MessageService,
		private travelAgentProfileService: TravelAgentProfileService,
		private confirmationService: ConfirmationService,
    private activatedRoute: ActivatedRoute,
    private dialog: MatDialog,
		@Inject(MAT_DIALOG_DATA) data: any)
		{
		this.title = data?.title;
		this.showFilter = data?.showFilter;
		this.showPagination = data?.showPagination;
		this.displayClose = data?.displayClose;
		this.reservationId = data?.reservationId;
		this.ruReservationId = data?.ruReservationId;
		this.statuses = reservationLedgerService.statuses;
		this.payToDetails = reservationLedgerService.payToDetails;
		this.percentages = travelAgentProfileService.percentages;
		this.isPopup = data?.isPopup;

      if (this.reservationId == null){
        this.activatedRoute.params.subscribe(params =>
        {
          this.reservationId = params.reservationId;
          this.showFilter = true;
        });
      }
	}



	// data
	reservationLedgers: any;
	reservationLedger: ReservationLedger;

	// paging
	first = 0;
	rows = 50;

	// list
	datasource: any;

	recordTotal: number;
	lazyLoadEvent: LazyLoadEvent;
	loading = true;
	multiSortMeta = [];

	// forms
	formLoading = false;

	statuses: any;

	form2: UntypedFormGroup;

	form1: UntypedFormGroup;

	monthsForBulkGenerateStatement: any[] = [
    { value: 1, name: 'Jan' },
    { value: 2, name: 'Feb' },
    { value: 3, name: 'Mar' },
    { value: 4, name: 'April' },
    { value: 5, name: 'May' },
    { value: 6, name: 'June' },
    { value: 7, name: 'July' },
    { value: 8, name: 'Aug' },
    { value: 9, name: 'Sept' },
    { value: 10, name: 'Oct' },
    { value: 11, name: 'Nov' },
    { value: 12, name: 'Dec' },
  ]

  yearsForBulkGenerateStatement: any[] = [
    { value: 2025, name: '2025' },
    { value: 2026, name: '2026' },
    { value: 2027, name: '2027' },
    { value: 2029, name: '2029' },
    { value: 2030, name: '2030' },
    { value: 2031, name: '2031' },
    { value: 2032, name: '2032' },
    { value: 2033, name: '2033' },
    { value: 2034, name: '2034' },
    { value: 2035, name: '2035' },
    { value: 2036, name: '2036' },
    { value: 2037, name: '2037' },
    { value: 2038, name: '2038' },
    { value: 2028, name: '2028' },
    { value: 2039, name: '2039' },
    { value: 2040, name: '2040' },
    { value: 2041, name: '2041' },
  ]

	validationMessages2 = {
    month: [{ type: 'required', message: 'Required' }],
    year: [{ type: 'required', message: 'Required' }],
  };

  validationMessages = {
    reservationId: [{ type: 'required', message: 'Required' }],
    agentPCT: [{ type: 'required', message: 'Required' }],
	agentAMT: [{ type: 'required', message: 'Required' }],
	agentName: [{ type: 'required', message: 'Required' }],
	privateNotes: []
  };

	columns: any[] = [
		{ field: 'propertyCode', header: 'Property', width: 'auto', sortingField: 'reservationVO.shortTermRentalVO.propertyCode' },
		// { field: 'guestLastName', header: 'Name', width: 'auto', sortingField: 'reservationVO.guestProfileVO.lastName' },
		// { field: 'status', header: 'Status', width: 'auto' },
		// { field: 'checkInDateTime', header: 'In', width: 'auto', sortingField: 'reservationVO.checkInDateTime' },
		// { field: 'checkOutDateTime', header: 'Out', width: 'auto', sortingField: 'reservationVO.checkOutDateTime' },
		{ field: 'orderProductName', header: 'Title', width: 'auto', sortingField: 'orderProductVO.name' },
		{ field: 'payFromOrderProductName', header: 'Pay From Order Prod', width: 'auto', sortingField: 'payFromOrderProductVO.name' },
		{ field: 'payFrom', header: 'PayFrom', width: 'auto', sortingField: 'payFrom' },
		{ field: 'payTo', header: 'PayTo', width: 'auto', sortingField: 'payTo' },
		{ field: 'quantity', header: 'Qty', width: 'auto', sortingField: 'quantity' },
		{ field: 'listPrice', header: 'Price', width: 'auto', sortingField: 'listPrice' },
		{ field: 'listPriceAdjustmentPercent', header: 'LPA %', width: 'auto', sortingField: 'listPriceAdjustmentPercent' },
		{ field: 'listPriceAdjustmentAmount', header: 'LPA $', width: 'auto', sortingField: 'listPriceAdjustmentAmount' },
	];

	excelColumns: any[] = [
		{ field: 'propertyCode', header: 'Property', width: 'auto', sortingField: 'reservationVO.shortTermRentalVO.propertyCode' },
		// { field: 'guestLastName', header: 'Name', width: 'auto', sortingField: 'reservationVO.guestProfileVO.lastName' },
		// { field: 'status', header: 'Status', width: 'auto' },
		// { field: 'checkInDateTime', header: 'In', width: 'auto', sortingField: 'reservationVO.checkInDateTime' },
		// { field: 'checkOutDateTime', header: 'Out', width: 'auto', sortingField: 'reservationVO.checkOutDateTime' },
		{ field: 'orderProductName', header: 'Title', width: 'auto', sortingField: 'orderProductVO.name' },
		{ field: 'payFromOrderProductName', header: 'Pay From Order Prod', width: 'auto', sortingField: 'payFromOrderProductVO.name' },
		{ field: 'payFrom', header: 'PayFrom', width: 'auto', sortingField: 'payFrom' },
		{ field: 'payTo', header: 'PayTo', width: 'auto', sortingField: 'payTo' },
		{ field: 'quantity', header: 'Qty', width: 'auto', sortingField: 'quantity' },
		{ field: 'listPrice', header: 'Price', width: 'auto', sortingField: 'listPrice' },
		{ field: 'listPriceAdjustmentPercent', header: 'LPA %', width: 'auto', sortingField: 'listPriceAdjustmentPercent' },
		{ field: 'listPriceAdjustmentAmount', header: 'LPA $', width: 'auto', sortingField: 'listPriceAdjustmentAmount' },
		{ field: 'total', header: 'Total', width: 'auto', sortingField: '' },

	];

	ngOnInit(): void {
		this.formBuild2();
		this.formBuild();
		try {
			// default sort of list
			this.multiSortMeta = [];
			this.multiSortMeta.push({ field: 'orderProductVO.orderProductId', order: 1 });
			this.multiSortMeta.push({ field: 'payFromOrderProductVO.orderProductId', order: 1 });
			this.multiSortMeta.push({ field: 'ledgerItemType', order: 1 });
		}
		catch (error) {
			console.log('Error: ' + error);
		}
	}

	revenueTypeOptions: any[] = [
    { value: 1, name: 'Debit with Tax (default for refund)' },
    { value: 2, name: 'Debit without Tax' },
    { value: 3, name: 'Debit without KBM Fee' },
    { value: 4, name: 'Debit without Tax & KBM Fee' },
    { value: 5, name: 'Credit with Tax (default for revenue)' },
    { value: 6, name: 'Credit without Tax' },
    { value: 7, name: 'Credit without KBM Fee' },
    { value: 8, name: 'Credit without Tax & KBM Fee' },
  ];

  stmtPreview: any = null;
  isPreviewLoading = false;

  previewBulkStatement() {
    try {
      this.form2.markAllAsTouched();
      if (this.form2.invalid) return;
      this.isPreviewLoading = true;
      this.stmtPreview = null;
      const payload = {
        reservationId: this.reservationId,
        month: this.form2.value.month,
        year: this.form2.value.year,
        numNights: this.form2.value.numNights || null,
        revenueAmt: this.form2.value.revenueAmt ?? null,
        revenueType: this.form2.value.revenueType ?? null,
      };
      this.reservationLedgerService.previewBulkStatement(payload).subscribe(
        (res: any) => {
          this.isPreviewLoading = false;
          this.stmtPreview = res?.data?.ownerStmtRez;
        },
        (err: any) => {
          this.isPreviewLoading = false;
          this.messageService.add({ severity: 'error', summary: 'Preview Failed', detail: err?.error?.message || 'Could not generate preview.', life: 5000 });
        }
      );
    } catch (error) {
      this.isPreviewLoading = false;
      this.alertService.error(error);
    }
  }

  getNetRevenueDetail(): any {
    return this.stmtPreview?.ownerStmtDetails?.find((d: any) => d.orderProductId === 200);
  }

  getMgmtFeeDetail(): any {
    return this.stmtPreview?.ownerStmtDetails?.find((d: any) => d.orderProductId === 201);
  }

  getReservationStatusLabel(status: string): string {
    const map: any = { 'OP': 'Reserved', 'CO': 'Checked Out', 'CI': 'Checked In', 'CN': 'Cancelled', 'PB': 'Pre-Booking' };
    return map[status] || status || '';
  }

  getTaxTooltip(detail: any): string {
    if (!detail?.ownerStmtDetailTaxes?.length) return '';
    return detail.ownerStmtDetailTaxes
      .map((t: any) => `${t.taxName} (${t.taxRate}%): $${(t.taxAmount ?? 0).toFixed(2)}`)
      .join('\n');
  }

	formBuild2() {
    this.form2 = this.formBuilder.group({
      month: [0, Validators.required],
      year: [0, Validators.required],
      numNights: [null],
      revenueAmt: [null],
      revenueType: [null],
    });
  }

  formBuild() {
    this.form1 = this.formBuilder.group({
      reservationId: [this.reservationId],
      agentPCT: ['', Validators.required],
	  agentAMT: ['', Validators.required],
	  agentName: ['', Validators.required],
	  privateNotes: [],
	  travelAGENTProfileId: [null],
    });
  }

  searchAgentProfiles(event: any) {
    this.travelAgentProfileService.findByFilter(0, 10, 'firstName', 1, null, event.query, { portalAccess: { value: [1, 2], matchMode: 'in' } })
      .subscribe((res: any) => {
        const profiles = res?.data?.travelAgentProfiles || [];
        this.agentProfileSuggestions = profiles.map((p: any) => ({
          ...p,
          displayName: [p.firstName, p.lastName].filter(Boolean).join(' ') + (p.agencyName ? ' (' + p.agencyName + ')' : '')
        }));
      }, () => { this.agentProfileSuggestions = []; });
  }

  onAgentSelect(event: any) {
    const profile = event.value ?? event;
    const fullName = [profile.firstName, profile.lastName].filter(Boolean).join(' ');
    this.form1.patchValue({
      agentName: fullName,
      agentPCT: profile.defaultCommissionPCT ?? '',
      travelAGENTProfileId: profile.travelAgentProfileId ?? null
    });
  }

	/*********
	 * Delete Button
	 *
	 */
	onRowDelete(event: any) {
		console.log('onRowDelete: ' + JSON.stringify(event));
		this.confirmationService.confirm({
			message: 'Are you sure you want to delete Id# ' + event.reservationLedgerId + '?',
			header: 'Confirm',
			icon: 'pi pi-exclamation-triangle',
			accept: () => {
				this.formDelete(event);
			},
			reject: () => {
				this.messageService.add({ severity: 'info', summary: 'Canceled', detail: 'Delete canceled.', life: 3000 });
			}
		});
	}

  onRegenerateTax(reservationId: any) {
    console.log('onRowDelete: ' + JSON.stringify(event));
    this.confirmationService.confirm({
      message: 'Are you sure you want to reGenerate tax?',
      header: 'Confirm',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        try {
          // stop here if form is invalid
          this.formLoading = true;
          this.reservationLedgerService.reGenerateTax(reservationId)
            .subscribe(
              (res: any) => {
                this.messageService.add({ severity: 'success', summary: 'Successful', detail: 'ReGenerated tax for reservation#' + reservationId, life: 3000 });
                this.loadLazy(this.lazyLoadEvent);
              },
              (err: any) => {
                this.messageService.add({ severity: 'error', summary: 'ReGenerate Tax Failed', detail: 'Reservation#' + reservationId + ' ', life: 3000 });
              },
              () => { this.formLoading = false; });
        } catch (error) {
          console.log('Form Invalid: ' + JSON.stringify(error));
          this.alertService.error(error);
        }
      },
      reject: () => {
        this.messageService.add({ severity: 'info', summary: 'Canceled', detail: 'Delete canceled.', life: 3000 });
      }
    });
  }


	onDeleteByReservationId(reservationId: any) {
		console.log('onRowDelete: ' + JSON.stringify(event));
		this.confirmationService.confirm({
			message: 'Are you sure you want to delete all ledger entires?',
			header: 'Confirm',
			icon: 'pi pi-exclamation-triangle',
			accept: () => {
				try {
					// stop here if form is invalid
					this.formLoading = true;
					this.reservationLedgerService.deleteAllByReservationId(reservationId)
						.subscribe(
							(res: any) => {
								this.messageService.add({ severity: 'success', summary: 'Successful', detail: 'ReservationLedger Deleted for reservation#' + reservationId, life: 3000 });
								this.loadLazy(this.lazyLoadEvent);
							},
							(err: any) => {
								this.messageService.add({ severity: 'error', summary: 'Delete Failed', detail: 'Reservation#' + reservationId + ' ledgers could not be deleted.', life: 3000 });
							},
							() => { this.formLoading = false; });
				} catch (error) {
					console.log('Form Invalid: ' + JSON.stringify(error));
					this.alertService.error(error);
				}
			},
			reject: () => {
				this.messageService.add({ severity: 'info', summary: 'Canceled', detail: 'Delete canceled.', life: 3000 });
			}
		});
	}


	/*********
	 * Lazy Load All Data
	 *
	 */
	loadLazy(event: LazyLoadEvent) {
		try {
			this.loading = true;
			this.lazyLoadEvent = event;

			console.log(
				' event.first:' + event.first
				+ '  |  event.rows:' + event.rows
				+ '  |  event.sortField:' + event.sortField
				+ '  |  event.sortOrder:' + event.sortOrder
				+ '  |  event.multiSortMeta:' + JSON.stringify(event.multiSortMeta)
				+ '  |  event.globalFilter:' + event.globalFilter
				+ '  |  event.filters:' + JSON.stringify(event.filters)
			);

			/*
			*
			* Default Sort
			*/
			// https://stackoverflow.com/questions/679915/how-do-i-reservationLedger-for-an-empty-javascript-object
			// if we are NOT filtering and we are NOT sorting, apply a default sort
			if (Object.keys(event.filters).length === 0 && !event.multiSortMeta) {
				event.multiSortMeta = [];
				event.multiSortMeta.push({ field: 'createDate', order: -1 });
			}

			if (this.reservationId) {
				// show only activities that are assigned to this activityProviderId
				let reservationIdFilter = { 'reservationVO.reservationId': { 'value': this.reservationId, 'matchMode': 'in' } };
				Object.assign(event.filters, reservationIdFilter);
			}

			const pageNumber = Math.round(event.first / event.rows);
			this.reservationLedgerService.findByFilter(
				pageNumber, event.rows,
				event.sortField,
				event.sortOrder,
				event.multiSortMeta,
				event.globalFilter,
				event.filters).pipe(first()).subscribe(

					(res: any) => {
						this.datasource = res.data.reviews;
						this.recordTotal = res.page.recordTotal;
						this.reservationLedgers = res.data.reservationLedgers;
						console.log(JSON.stringify(res.page));
					},
					(err: any) => {
						console.log('reviews list error!: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.loading = false; }
				);

			if (this.datasource) {
				this.reservationLedgers = this.datasource.slice(event.first, (event.first + event.rows));
			}
		} catch (error) {
			console.log('loadLazy(' + event + ')' + error);
		}
	}

	getStatus() {
		return;
	}

	/*********
	 * onRowSelect()
	 * Used to handle row click (to edit, link, etc)
	 */
	onRowSelect(event: any) {
		console.log('onRowSelect: ' + JSON.stringify(event));
		this.onOpenFormEdit(event.data);
	}

	// handled in rate-bucket-form
	formAdd() { }


	/*********
	 * formUpdate()
	 * Used for row editing
	 */
	formUpdate(reservationLedger: ReservationLedger) {
		try {
			this.formLoading = true;
			this.reservationLedgerService.update(reservationLedger)
				.subscribe(
					(res: any) => {
						console.log('Rate-Bucket-Update SUCCESS: ' + JSON.stringify(res));
						this.reservationLedgers.map((reservationLedger, i) => {
							if (reservationLedger.reservationLedgerId === res.data.reservationLedger.reservationLedgerId) {
								this.reservationLedgers[i] = res.data.reservationLedger;
							}
						});
						// this.alertService.success(res, true);
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
					},
					(err: any) => {
						console.log('Rate-Bucket-Update FAIL: ' + JSON.stringify(err));
						this.messageService.add({ severity: 'error', summary: JSON.stringify(err), life: 3000 });
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	/*********
	 * formDelete()
	 * Used for row editing
	 */
	formDelete(reservationLedger: any) {
		try {
			// stop here if form is invalid
			console.log('Delete Submitted: ' + JSON.stringify(reservationLedger));

			this.formLoading = true;
			this.reservationLedgerService.delete(reservationLedger.reservationLedgerId)
				.subscribe(
					(res: any) => {
						console.log('Rate-Bucket-Delete SUCCESS: ' + JSON.stringify(res));
						this.reservationLedgers.splice(this.reservationLedgers.indexOf(reservationLedger), 1);
						this.recordTotal = this.reservationLedgers.length;
						this.messageService.add({ severity: 'success', summary: 'Successful', detail: 'ReservationLedger ' + reservationLedger.reservationLedgerId + ' Deleted', life: 3000 });
					},
					(err: any) => {
						console.log('Rate-Bucket-Delete  FAIL: ' + JSON.stringify(err));
						this.messageService.add({ severity: 'error', summary: 'Delete Failed', detail: 'ReservationLedger ' + reservationLedger.reservationLedgerId + ' could not be deleted.  Be sure there are no assigned properties to this bucket.', life: 3000 });
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	/*********
		 * Add New Button
		 *
		 */
	onOpenFormAdd() {

		const dialogConfig = new MatDialogConfig();

		// settings
		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = true;
		dialogConfig.hasBackdrop = true;
		dialogConfig.maxWidth = '60vw';
			dialogConfig.width = '40vw';

		// pass data, ie reservationId: this.reservationId, to load reservation Agent APIs data
		let reservationLedger = {
			reservationId : this.reservationId

		};
		dialogConfig.data = {
			title: 'Add ReservationLedger',
			reservationLedger: reservationLedger,
		};

		// open the popup and get a reference to it called dialogRef
		const dialogRef = this.dialog.open(ReservationLedgerComponent, dialogConfig);

		// to receive the added element, subscribe to the eventEmitter we created 'doAdd' in the element to handle adding
		dialogRef.componentInstance.doAdd.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.addReservationLedgerCB(data);

				// close the dialogBox
				dialogRef.close();
			});
	}


	/*********
		* Edit Button
		*
		*/
	onOpenFormEdit(reservationLedger: ReservationLedger) {

		const dialogConfig = new MatDialogConfig();

		// settings
		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = true;
		dialogConfig.hasBackdrop = true;
		dialogConfig.maxWidth = '60vw';
			dialogConfig.width = '30vw';

		// pass data, ie rateBuicket: this.shortTermRentalId,
		dialogConfig.data = {
			reservationLedger: reservationLedger,
			title: 'Edit ReservationLedger'
		};

		// open the popup and get a reference to it called dialogRef
		const dialogRef = this.dialog.open(ReservationLedgerComponent, dialogConfig);

		// to receive the added element, subscribe to the eventEmitter we created 'doUpdate' in the element to handle updating the list
		dialogRef.componentInstance.doUpdate.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.updateReservationLedgerCB(data);

				// close the dialogBox
				dialogRef.close();
			});

		dialogRef.componentInstance.doDelete.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.deleteReservationLedgerCB(data);

				// close the dialogBox
				dialogRef.close();
			});
	}


	/**
	   *
	   * Dialog from Form Callbacks
	   * To edit the list show add/edit/delete in real time from the popup form
	   *
	   */
	addReservationLedgerCB(reservationLedger: ReservationLedger) {
		console.log('Adding ReservationLedger: ' + JSON.stringify(reservationLedger));
		// RefreshTable to recalculate ledger amount
		this.refreshTable();
		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'ReservationLedger ' + reservationLedger.reservationLedgerId + ' Added', life: 3000 });
	}

	updateReservationLedgerCB(reservationLedger: ReservationLedger) {
		console.log('Updating ReservationLedger: ' + JSON.stringify(reservationLedger));
	/*	let itemIndex = this.reservationLedgers.findIndex((item: any) => item.reservationLedgerId === reservationLedger.reservationLedgerId);
		this.reservationLedgers[itemIndex] = reservationLedger;

		// no idea what this is but it is required to update the array
		this.reservationLedgers = [...this.reservationLedgers];*/
		// RefreshTable to recalculate ledger amount
		this.refreshTable();

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'ReservationLedger ' + reservationLedger.reservationLedgerId + ' Updated', life: 3000 });
	}

	deleteReservationLedgerCB(reservationLedger: ReservationLedger) {
		console.log('Removing ReservationLedger: ' + reservationLedger);
		/*this.reservationLedgers.splice(this.reservationLedgers.indexOf(reservationLedger), 1);
		this.recordTotal = this.reservationLedgers.length;

		// no idea what this is but it is required to update the array
		this.reservationLedgers = [...this.reservationLedgers];*/
		// RefreshTable to recalculate ledger amount
		this.refreshTable();

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'ReservationLedger ' + reservationLedger.reservationLedgerId + ' Deleted', life: 3000 });
	}

	/**********
	 *
	 * PAGINATOR FUNCTIONS
	 */
	next() { this.first = this.first + this.rows; }
	prev() { this.first = this.first - this.rows; }
	reset() { this.first = 0; }
	isLastPage(): boolean { return this.reservationLedgers ? this.first === (this.reservationLedgers.length - this.rows) : true; }
	isFirstPage(): boolean { return this.reservationLedgers ? this.first === 0 : true; }

	get Statuses() {
		return this.statuses;
	}

	getStatusName(reservationLedger: any) {
		if (reservationLedger?.status) {
			const status = this.statuses.find((e: any) => e.value == reservationLedger.status);
			return status.name;
		}
		else {
			return '';
		}
	}

	getPayToName(reservationLedger: any) {
		if (reservationLedger?.payTo) {
			const status = this.payToDetails.find((e: any) => e.value == reservationLedger.payTo);
			return status.name;
		}
		else {
			return '';
		}
	}
	getPayFromName(reservationLedger: any) {
		if (reservationLedger?.payFrom) {
			const status = this.payToDetails.find((e: any) => e.value == reservationLedger.payFrom);
			return status.name;
		}
		else {
			return '';
		}
	}

	reloadPage() {
		window.location.reload();
	}

	generateLedgers() {
		this.isSearching = true;
		try {
			this.reservationLedgerService.generateLedgers(this.reservationId)
				.subscribe(
					res => {
						this.isSearching = false;
						console.log('findAllReservations: ' + JSON.stringify(res));
						this.loadLazy(this.lazyLoadEvent);
						// this.reservations = res.data.reservations;
						// return this.reservations;
					},
					err => {
						this.isSearching = false;
						console.log('Feature-Update FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { });
		} catch (error) {
			this.isSearching = false;
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	reGenerateNetIncome() {
		this.isSearching = true;
		try {
			this.reservationLedgerService.reGenerateNetIncome(this.reservationId)
				.subscribe(
					res => {
						this.isSearching = false;
						console.log('findAllReservations: ' + JSON.stringify(res));
						this.loadLazy(this.lazyLoadEvent);
					},
					err => {
						this.isSearching = false;
						console.log('Feature-Update FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { });
		} catch (error) {
			this.isSearching = false;
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	syncRuCreditVoucher() {
		this.isSearching = true;
		try {
			this.reservationLedgerService.syncRuCreditVoucher(this.ruReservationId)
				.subscribe(
					res => {
						this.isSearching = false;
						console.log('findAllReservations: ' + JSON.stringify(res));
						// this.reservations = res.data.reservations;
						// return this.reservations;
						this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Sync credit voucher payment successfully.' });
					},
					err => {
						this.isSearching = false;
						console.log('Feature-Update FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { });
		} catch (error) {
			this.isSearching = false;
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	toggleLedgerItemsLock(reservationLedger: any) {
		this.isSearching = true;
		try {
			this.reservationLedgerService.toggleLedgerItemsLock(reservationLedger?.reservationLedgerId)
				.subscribe(
					res => {
						this.isSearching = false;
						console.log('findAllReservations: ' + JSON.stringify(res));
						this.loadLazy(this.lazyLoadEvent);
						// this.reservations = res.data.reservations;
						// return this.reservations;
					},
					err => {
						this.isSearching = false;
						console.log('Feature-Update FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { });
		} catch (error) {
			this.isSearching = false;
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	lockLedger() {
		this.isSearching = true;
		try {
			this.reservationLedgerService.lockLedger(this.reservationId)
				.subscribe(
					res => {
						this.isSearching = false;
						console.log('findAllReservations: ' + JSON.stringify(res));
						this.loadLazy(this.lazyLoadEvent);
						// this.reservations = res.data.reservations;
						// return this.reservations;
					},
					err => {
						this.isSearching = false;
						console.log('Feature-Update FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { });
		} catch (error) {
			this.isSearching = false;
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	unlockLedger() {
		this.isSearching = true;
		try {
			this.reservationLedgerService.unlockLedger(this.reservationId)
				.subscribe(
					res => {
						this.isSearching = false;
						console.log('findAllReservations: ' + JSON.stringify(res));
						this.loadLazy(this.lazyLoadEvent);
						// this.reservations = res.data.reservations;
						// return this.reservations;
					},
					err => {
						this.isSearching = false;
						console.log('Feature-Update FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { });
		} catch (error) {
			this.isSearching = false;
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	total(reservationLedger: any){
		return (reservationLedger?.quantity * reservationLedger?.listPrice);
	}

	getTaxRowStyle(reservationLedger: any){
		return reservationLedger?.ledgerItemType === 2 ? 'lightgrey' : '';
	}
	getReservationLedgerTitle(reservationLedger: any){
		let orderProductName = reservationLedger?.orderProductName;
		let isTax = reservationLedger?.ledgerItemType === 2 || false;
		if (isTax && reservationLedger.title){
			return  orderProductName + ':' + reservationLedger?.title  + ' (' + reservationLedger?.opsNotes + '%)';
		}
		return orderProductName;
	}

	grandTotal(){
		this.grandTotalAmount = 0;
		this.reservationLedgers.forEach(reservationLedger => {
			this.grandTotalAmount = this.grandTotalAmount + (reservationLedger?.quantity * reservationLedger?.listPrice);
		});
		return this.grandTotalAmount;
	}

	netIncome(){
		let netIncome = 0;
		this.reservationLedgers.forEach(reservationLedger => {
			if ((reservationLedger.ledgerItemType == 1) && (reservationLedger.orderProductId === 105 || reservationLedger.orderProductId == 106)){
				netIncome += (reservationLedger?.quantity * reservationLedger?.listPrice);
			}
		});
		return netIncome;
	}
	netTax(){
		let netIncome = 0;
		this.reservationLedgers.forEach(reservationLedger => {
			if ((reservationLedger.ledgerItemType == 2) && (reservationLedger.orderProductId === 105 || reservationLedger.orderProductId == 106)){
				netIncome += (reservationLedger?.quantity * reservationLedger?.listPrice);
			}
		});
		return netIncome;
	}
	netIncomeWithTax(){

		return this.netTax() + this.netIncome();
	}

	refreshTable(){this.loadLazy(this.lazyLoadEvent); }

	exportAsExcelFile($event): void {
		let data = [];
		try {
			this.reservationLedgers.forEach((e) => {
				let row = {
					propertyCode: e.propertyCode,
					orderProductName: this.getReservationLedgerTitle(e),
					payFromOrderProductName: e.payFromOrderProductName,
					payFrom: this.getPayFromName(e),
					payTo: this.getPayToName(e),
					quantity: e.quantity,
					listPrice: e.listPrice,
					listPriceAdjustmentPercent: e.listPriceAdjustmentPercent,
					listPriceAdjustmentAmount: e.listPriceAdjustmentAmount,
					total :  this.total(e)

				};

				data.push(row);
			});
		}catch (e){

		}
		this.importExportComponent.exporData($event, data, 'ReservationLedger#' + this.reservationId + '_');
	}

	addIntoOwnerStatementPopUpDisplay(){
		this.addIntoOwnerStatementPopUp = true;
	}

	addTravelAgentPopUpDisplay(){
		this.addTravelAgentPopUp = true;
		this.selectedAgentProfile = null;
		this.form1.reset({ reservationId: this.reservationId, travelAGENTProfileId: null });
	}

	// Generate Bulk Statement method
  generateBulkStatement() {
    try {
      // stop here if form is invalid
      this.form2.markAllAsTouched();
      if (this.form2.invalid) {
        return;
      }
      this.formLoading = true;
      const payload = {
        reservationId: this.reservationId,
        month: this.form2.value.month,
        year: this.form2.value.year,
        numNights: this.form2.value.numNights || null,
        revenueAmt: this.form2.value.revenueAmt ?? null,
        revenueType: this.form2.value.revenueType ?? null,
      };
      this.reservationLedgerService.generateBulkStatement(payload)
        .subscribe(
          (res: any) => {
            this.formLoading = false;
            this.addIntoOwnerStatementPopUp = false;
            this.messageService.add({ severity: 'success', summary: 'Success', detail: "Reservation added into owner statement successfully." });
          },
          (err: any) => {
            // Do NOT reset formLoading on error — a 504 means the statement generation may have
            // already completed. Keep button disabled to block re-submit.
            console.log('generateBulkStatement FAIL: ' + JSON.stringify(err));
            this.alertService.error(err);
          },
          () => { });

    } catch (error) {
      this.formLoading = false;
      this.alertService.error(error);
    }
  }

  // Generate Bulk Statement method
  addTravelAgent() {
    try {
      // stop here if form is invalid
      this.form1.markAllAsTouched();
      if (this.form1.invalid) {
        return;
      }
      this.formLoading = true;
      this.reservationLedgerService.addTravelAgent(this.form1.value)
        .subscribe(
          (res: any) => {
            this.formLoading = false;
			this.addTravelAgentPopUp = false;
			this.loadLazy(this.lazyLoadEvent);
              this.messageService.add({ severity: 'success', summary: 'Success', detail: "Added Travel Agent Successful" });
          },
          (err: any) => {
            // Do NOT reset formLoading on error — a 504 means the travel agent may have been added.
            // Keep button disabled to block re-submit.
            console.log('addTravelAgent FAIL: ' + JSON.stringify(err));
            this.alertService.error(err);
          },
          () => { });

    } catch (error) {
      this.formLoading = false;
      this.alertService.error(error);
    }
  }
}
